<template>
  <div>
    <div ref="customergroup_selector">
      <BaseSelectorField
        v-model="query_params.search"
        :multiple="multiple"
        :selectedItems="selectedItems"
        :objectName="multiple ? null : selectedItems[0]?.name"
        :placeholder="disabled ? null : `Select ${!multiple ? modelName.singular : modelName.plural}`"
        :inputClasses="inputClasses"
        :label="label"
        :disabled="disabled"
        :validation="validation"
        :hasWarning="hasWarning"
        :warningMessage="warningMessage"
        :hideMessage="hideMessage"
        :loading="loading || addLoading"
        :searching="searching"
        :required="required"
        :isVoid="isVoid"
        @open-dialog="openModal"
        @clear-selection="clearSelection"
        @focus="handleFieldFocus"
        @blur="handleFieldBlur"
        @query="query"
        @remove-item="removeItem"
        tabindex="1"
      />

      <BaseDialogSelectorList
        displayName="name"
        matchKey="id"
        :open="listVisible"
        :items="query_data?.results"
        :target="$refs.customergroup_selector"
        :searching="searching"
        :selectedItems="selectedItems"
        :modelName="modelName"
        :enableNew="!disableAdd || (!!query_params.search && query_params.search != selectedItems[0]?.name && !disableQuickAdd)"
        @selected="selectItem"
        @create="create"
        @clear="clearSelection"
        @update:open="listVisible = $event"
      >
        <template v-if="!!query_params.search && query_params.search != selectedItems[0]?.name && !disableQuickAdd" v-slot:new-item>
          <span class="d-flex align-items-center">
            <i class="bx bx-plus-circle p-0 me-1"></i>
            Quick Add "{{ query_params.search }}"
          </span>
        </template>
      </BaseDialogSelectorList>
    </div>

    <EditCustomerGroupModal v-if="!disableAdd && !disableModals" :newDetails="{ name: query_params.search }" ref="new_modal" @upserted="selectItem([$event])" />

    <BaseSelectorDialog 
      v-model="query_params.search" 
      ref="dialog" 
      :modelName="modelName" 
      :disableAdd="disableAdd"
      :disableQuickAdd="disableQuickAdd"
      :loading="addLoading"
      @create="create" 
      @open="dialogOpen = true"
      @close="dialogOpen = false"
      hideButton
    >
      <template #filters>
        <slot name="filters">

        </slot>
      </template>

      <template #table>
        <BaseTable
          ref="table"
          :selectMode="multiple ? 'multi' : 'single'"
          :data_="query_data"
          :fields="fields"
          :selected.sync="selectedItems"
          :defaultPageSize="query_params.page_size"
          :modelName="modelName"
          :loading="queryLoading"
          @page_change="query_params.page = $event"
          @page_size_change="query_params.page_size = $event"
          @ordering_change="query_params.ordering = $event"
          @selected="() => { if (!multiple) $refs.dialog.hide() }"
          :rowClickable="!multiple"
        />
      </template>
    </BaseSelectorDialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { formatPercent } from '@/state/utils'

import BaseDialogSelector from "@/components/shared/BaseDialogSelectors/BaseDialogSelector.vue";
import EditCustomerGroupModal from "@/router/views/customer-groups/EditCustomerGroupModal.vue";

export default {
  extends: BaseDialogSelector,
  components: {
    EditCustomerGroupModal,
  },
  props: {
    label: { type: String, default: "Customer Group", },
    disableQuickAdd: { type: Boolean, default: false, }
  },
  data() {
    return {
      fields: [
        { key: "name", sortable: true },
        { key: "parent.name", label: "Parent" },
      ],
      modelName: { singular: "Customer Group", plural: "Customer Groups" },
    };
  },
  methods: {
    ...mapActions("customerGroups", ["fetchCustomerGroups", "upsertCustomerGroup"]),
    
    async create() {
      if (!this.disabled && !this.searching) {
        if ( !this.dialogOpen && !this.disableQuickAdd && this.query_params.search && this.listVisible && this.query_params.search !== this.selectedItems[0]?.name ) {
          this.addLoading = true;
          try {
            const res = await this.upsertCustomerGroup({ id: null, archived: false, name: this.query_params.search, pos_folder: false });
            const newCustomerGroup = res.data.data;
            this.query_data.results.push(newCustomerGroup);
            if (this.multiple) {
              this.selectedItems.push(newCustomerGroup);
            } else {
              this.selectedItems = [newCustomerGroup];
              document.activeElement && document.activeElement.blur();
              this.$refs.dialog.hide();
              this.listVisible = false;
            }
            this.$emit('select', this.multiple ? this.selectedItems : newCustomerGroup);
          } catch {
          } finally {
            this.addLoading = false;
          }
        } else if (!this.disableAdd) {
          setTimeout(() => {
            this.$refs.new_modal.initialize();
            this.$refs.new_modal.show();
          }, 100);
        }
      }
    },

    query() {
      this.queryLoading = true;
      this.searching = true;
      this.fetchCustomerGroups({
          ...this.query_params,
      }).then((res) => {
          this.query_data = res.data;
      }).finally(() => {
        this.queryLoading = false;
        this.searching = false;
      });
    },

    formatPercent,
  },
};
</script>